import React from 'react'

export default function CustomContainer({ children }) {
    return <div style={{ maxWidth: '1150px !important' }}>{children}</div>
}
